<div id="fuse">
  <app-header></app-header>
  <router-outlet></router-outlet>
</div>
